var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.95 10C0.95 14.9904 5.00959 19.05 10 19.05C14.9904 19.05 19.05 14.9904 19.05 10C19.05 5.00959 14.9904 0.95 10 0.95C5.00959 0.95 0.95 5.00959 0.95 10ZM2.175 10C2.175 5.68513 5.68513 2.175 10 2.175C14.3149 2.175 17.825 5.68513 17.825 10C17.825 14.3149 14.3149 17.825 10 17.825C5.68513 17.825 2.175 14.3149 2.175 10Z",
    fill: "#6B7280",
    stroke: "#6B7280",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0625 10.6125H13.9375C14.2756 10.6125 14.55 10.3381 14.55 10C14.55 9.66188 14.2756 9.3875 13.9375 9.3875H6.0625C5.72438 9.3875 5.45 9.66188 5.45 10C5.45 10.3381 5.72438 10.6125 6.0625 10.6125Z",
    fill: "#6B7280",
    stroke: "#6B7280",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircle);
export default __webpack_public_path__ + "static/media/MinusCircle.07433441a6ba8eecc03c1aec8991a7c3.svg";
export { ForwardRef as ReactComponent };